module.exports = __webpack_public_path__ + "static/media/partner-icon-sundial-white.a110bbc3.svg";